import {v3} from "oc-threejs/short3";
import FachO3 from '../object3d/Fach';

export default class Fach {

    parent: Object;
    box = new THREE.Box3();
    size = v3();

    constructor(parent) {
        this.parent = parent;
    }

    compile() {
        APP.model.lazyCreateObject3d(this, () => {
            const o3 = new FachO3(this);
            this.parent.schrank.child3dContainer.add(o3);
            return o3;
        });
        this.size = this.box.getSize();
    }

    iterate(iterator) {
        iterator(this);
    }

}
